module.exports = __webpack_public_path__ + "src/assets/textures/spectro/plane_mat44.jpg";